export default __webpack_public_path__ + "static/media/06__o_0.167ecc8f.jpg";